<template>
    <div id="recursos_videos" class="container">

        <div class="row">
            <boton-atras :nombre_ruta="'modulo-planeacion'"></boton-atras>
            <div class="col-sm-12 col-md-6 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2 mt-1">Curso de Capacitación del Sistema Administrador de Formatos </h6>
                <i>
                    La Secretaría de Finanzas, te la bienvenida a la capacitación para uso del Sistema Administrador de Formatos, a través de videos que sirven como guia en el proceso de publicación de formatos oficiales.
                </i>
                <h6 class="mt-4 mx-0 px-0">Indice de videos</h6>
                <div class="pl-3 w-100">
                    <a @click="videoSeleccionado(1)" type="button" class="w-100">
                        <div class="mb-0 w-100">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-bottom-left-radius:0; border-bottom-right-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0">Bienvenida</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(2)" type="button" class="w-100">
                        <div class="mb-0">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0">Introducción</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(3)" type="button" class="w-100">
                        <div class="mb-2">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-top-left-radius:0; border-top-right-radius:0; ">
                                <div class="col-11 pr-0">
                                    <p class="m-0">Contenido</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(4)" type="button" class="w-100">
                        <div class="mb-2">
                            <div class="title_document row p-2 d-flex align-items-center">
                                <div class="col-11 pr-0">
                                    <h6 class="m-0">Capitulo 1.- Perfiles</h6>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(5)" type="button" class="w-100">
                        <div class="mb-2">
                            <div class="title_document row p-2 d-flex align-items-center">
                                <div class="col-11 pr-0">
                                    <h6 class="m-0">Capitulo 2.- Cuentas de Acceso e Inicio de Sesión </h6>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

                <h6 class="mt-4 mx-0 px-0">Capitulo 3.- Publicación de Formatos</h6>
                <div class="pl-3 mb-5">
                    <a @click="videoSeleccionado(6)" type="button" class="w-100">
                        <div class="mb-0">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-bottom-left-radius:0; border-bottom-right-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0">Búsqueda e Integración de Formatos</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(7)" type="button" class="w-100">
                        <div class="mb-0">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0">Revisión, Aceptado y Rechazado</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(8)" type="button" class="w-100">
                        <div class="mb-0">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0"> Autorizar y Publicar</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(9)" type="button" class="w-100">
                        <div class="mb-0">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0"> Inactivar Formato</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(10)" type="button" class="w-100">
                        <div class="mb-0">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0"> Agregar Nueva Revisión</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a @click="videoSeleccionado(11)" type="button" class="w-100">
                        <div class="mb-2">
                            <div class="title_document row p-2 d-flex align-items-center" style="border-top-left-radius:0; border-top-right-radius:0">
                                <div class="col-11 pr-0">
                                    <p class="m-0"> Eliminar Última Revisión</p>
                                </div>
                                <div class="col-1 pl-0 d-flex align-items-center">
                                    <p class="descargar text-gray m-0"><i class='fa fa-eye'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
            <div class="col-sm-12 col-md-6 order-1 order-sm-1 order-md-2 order-lg-2">
                <!-- <video :src="video" width="100%" controls  autoplay muted loop ></video> -->

<!-- YOUTUBE -->
                <div class="area_youtube mt-0"> <!--------img_fija----------->
                    <iframe width="100%" height="300" :src="urlYoutube" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div v-if="verNombreVideoSeleccionado" class="w-100 text-right">
                    <h5>{{name}}</h5>
                </div>

<!-- <iframe width="731" height="411" src="https://www.youtube.com/embed/VtJL_8MEAoc?list=PLcQKm559OGIe3lwfN6RGeATGX7AgAVSW_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->

            </div>


        </div>


    </div>
</template>
<script>
import botonAtras from '../../button-atras.vue'
export default {
    components:{
        botonAtras
    },
    data: function(){
        return{
            url: '/SitioNuevo/recursosPlaneacion/videos/',
            url2: 'https://www.youtube.com/embed/',
            url3: '?list=PLcQKm559OGIckBNKJ5fQveBSfh8jso1xL', //url3: '?list=PLcQKm559OGIe3lwfN6RGeATGX7AgAVSW_',
            video: '/SitioNuevo/recursosPlaneacion/videos/BIENVENIDA.mp4',
            name: 'Bienvenida',
            urlYoutube: 'https://www.youtube.com/embed/videoseries?list=PLcQKm559OGIckBNKJ5fQveBSfh8jso1xL', //VIDEO DE LA LISTA DE REPRODUCCIÓN ACTUAL => urlYoutube: 'https://www.youtube.com/embed/UFhLfEs2ME0?list=PLcQKm559OGIckBNKJ5fQveBSfh8jso1xL', //VIDEO DE LA LISTA DE REPRODUCCIÓN ANTERIOR => urlYoutube: 'https://www.youtube.com/embed/VtJL_8MEAoc?list=PLcQKm559OGIe3lwfN6RGeATGX7AgAVSW_',
            verNombreVideoSeleccionado: false,
        }
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    methods: {
        videoSeleccionado(n){
            // console.log(n);
            this.verNombreVideoSeleccionado = true;
                 if(n==1){ this.urlYoutube = this.url2 +'UFhLfEs2ME0'+this.url3; this.name = 'Bienvenida'; }
            else if(n==2){ this.urlYoutube = this.url2 +'1K1oFyy_qWk'+this.url3; this.name = 'Introducción'; }
            else if(n==3){ this.urlYoutube = this.url2 +'bM1u83tUfsI'+this.url3; this.name = 'Contenido'; }
            else if(n==4){ this.urlYoutube = this.url2 +'0PolvyLBsSI'+this.url3; this.name = 'Perfiles'; }

            else if(n==5){ this.urlYoutube = this.url2 +'R3YESSrqVbc'+this.url3; this.name = 'Cuentas de Acceso e Inicio de Sesión'; }
            else if(n==6){ this.urlYoutube = this.url2 +'Cpiz2ZKkavE'+this.url3; this.name = 'Búsqueda e Integración de Formatos'; }
            else if(n==7){ this.urlYoutube = this.url2 +'OInGJELaVa4'+this.url3; this.name = 'Revisión, Aceptado y Rechazado'; }
            else if(n==8){ this.urlYoutube = this.url2 +'QeF2QR51BZE'+this.url3; this.name = 'Autorizar y Publicar'; }
            else if(n==9){ this.urlYoutube = this.url2 +'Z3tPEaUJ7YQ'+this.url3; this.name = 'Inactivar Formato'; }
            else if(n==10){ this.urlYoutube = this.url2 +'HK5kIX4saXo'+this.url3; this.name = 'Agregar Nueva Revisión'; }
            else if(n==11){ this.urlYoutube = this.url2 +'Y-w_e5Hi3So'+this.url3; this.name = 'Eliminar Última Revisión'; }

            //LISTA DE REPRODUCCIÓN ANTERIOR
            // if(n==1){ this.urlYoutube = this.url2 +'VtJL_8MEAoc'+this.url3; this.name = 'Bienvenida'; }
            // else if(n==2){ this.urlYoutube = this.url2 +'VCEEe-d2HAY'+this.url3; this.name = 'Introducción'; }
            // else if(n==3){ this.urlYoutube = this.url2 +'erlyRQ4UDnU'+this.url3; this.name = 'Contenido'; }
            // else if(n==4){ this.urlYoutube = this.url2 +'4_amtLD6CzI'+this.url3; this.name = 'Perfiles'; }

            // else if(n==5){ this.urlYoutube = this.url2 +'q5jkx12sYqI'+this.url3; this.name = 'Cuentas de acceso e inicio de sesión'; }
            // else if(n==6){ this.urlYoutube = this.url2 +'aywt4XrJu60'+this.url3; this.name = 'Integración de formatos'; }
            // else if(n==7){ this.urlYoutube = this.url2 +'-M2SMM9HGE8'+this.url3; this.name = 'Revisión de formatos'; }
            // else if(n==8){ this.urlYoutube = this.url2 +'WchVokSIphw'+this.url3; this.name = 'Publicación de Formatos'; }

            window.scrollTo(0, 0);
        }
    }
}
</script>
<style scoped>
.text-gray{ color: #afbbc6;}
#recursos_videos .modal-dialog {
    max-width: 60% !important;
    margin: 1.75rem auto;
}

a { color: black; }

</style>
